(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

      const rawLocalization = this.querySelector("#HeaderCountryList")?.dataset.local;
      this.localization = rawLocalization?.split(",")?.filter(item => item !== "");

      this.custom_codes =  this.querySelector("#HeaderCountryList")?.dataset.codes;
      if(this.custom_codes) this.custom_codes = this.custom_codes.replace(/\s+/g, "").split(",");
      this.custom_links =  this.querySelector("#HeaderCountryList")?.dataset.links;
      if(this.custom_links) this.custom_links = this.custom_links.replace(/\s+/g, "").split(",");
      this.custom_countries =  this.querySelector("#HeaderCountryList")?.dataset.countries;
      if(this.custom_countries) this.custom_countries = this.custom_countries.replace(/\s+/g, "").split(",");
      this.current_domain = this.querySelector("#HeaderCountryList")?.dataset.domain;
      this.available_countries = this.querySelector("#HeaderCountryList")?.dataset.availablecountries ? JSON.parse(this.querySelector("#HeaderCountryList").dataset.availablecountries) : [];
      this.available_country_codes = this.querySelector("#HeaderCountryList")?.dataset.availableisocodes ? JSON.parse(this.querySelector("#HeaderCountryList").dataset.availableisocodes) : [];
  

      window.addEventListener("geoip-loaded", (e) => {
        this.currentCountry = window.geoData;
        this.handleGeoData(e.detail);
        if (this.querySelector(".location_popup_wrapper")) {
        this.show_popup = localStorage.getItem('location_state');
        window.addEventListener('resize', () => {
          this.show_popup = localStorage.getItem('location_state');
        })
      
        // CHECK IF CURRENTCOUNTRY CODE IS EQUAL TO DOMAIN, IF NOT DO THIS
        if((this.currentCountry.country_code !== this.current_domain) && this.show_popup == null || this.show_popup == false){
        this.querySelector(".location_popup_wrapper").style.display = "flex"
        document.body.style.overflow = 'hidden';
          this.buttons = this.querySelectorAll(".location_popup_button")
          this.buttons.forEach((button) => {
            button.addEventListener('click', () => {
              const url = button.querySelector(".button")?.getAttribute('href');
              if (url) {
                window.location.href = url;
              }
              localStorage.setItem('location_state', "true")
              this.querySelector(".location_popup_wrapper").style.display = "none"
              document.body.style.overflow = '';
            })
          })
        }
      }
      });
    }

    handleGeoData(geoJson) {
      let countryCode = geoJson.country_code;
      const suggestionWrapper = this.querySelector('#suggestedRedirect');
      if(this.custom_codes && !this.custom_codes.includes(countryCode) && !this.available_country_codes.includes(countryCode)) {
        if (suggestionWrapper) {
          suggestionWrapper.style.display = "none";
        }
        return ;
      }
      if(suggestionWrapper) {
        const countryElement = suggestionWrapper.querySelector('.suggested-country');
        if (countryElement) {
          const countrySpan = countryElement.querySelector('span');
          if (countrySpan) {
            const template = this.querySelector("#localization-flags");
            if(template) {
              const clone = template.content.cloneNode(true);
              let flag = clone.querySelector(`#${countryCode.toLowerCase()}-code svg`);
              if(flag) countrySpan.appendChild(flag.cloneNode(true));
            }
            countryElement.setAttribute('href', `https://drniedermaier.${countryCode.toLowerCase()}/`);
            const getCountryName = this.getCountryName(countryCode);
            countrySpan.appendChild(document.createTextNode(`${getCountryName}`));
          }
        }
      }
      return countryCode;
    }

    // get suggested country & remove it from all countries
    getCountryName(countryCode) {
      if (this.custom_codes && this.custom_codes.includes(countryCode)) {
        const index = this.custom_codes.indexOf(countryCode);
        if(index  !== -1) {
          const oldElement = this.querySelector(`#${countryCode}-render-custom`);
          if(oldElement) oldElement.remove();
          return this.custom_countries[index];
        }
      } else if(this.available_countries && this.available_country_codes.includes(countryCode)) {
        const index = this.available_country_codes.indexOf(countryCode);
        if(index  !== -1) {
          const oldElement = this.querySelector(`#${countryCode}-render-market`);
          if(oldElement) oldElement.remove();
          return this.available_countries[index];
        }
      }
      return ;
    }
    

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();

      if(event?.currentTarget?.hasAttribute("lang")) {
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      } else {
        const selectedValue = event?.currentTarget?.dataset?.value;
        if(selectedValue) window.location.href = `https://drniedermaier.${selectedValue.toLowerCase()}/`;
      }
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
